module.exports = __webpack_public_path__ + "img/d3.eda2431e.jpg";